import { ActionProgress } from "./action-progress.model";
import { Comment } from "./comment.model";

export interface Action {
    id: number;
    name: string;
    deadline?: number;
    minExpectation?: number;
    progress: ActionProgress[];
    weight?: number;
    isCommon?: boolean;

    comments: Comment[];
    // leaderId?: number;
    // leaderProgress?: number;
    // leader: Employee;

    createdBy?: string;
    createdOn?: Date;
    updatedBy?: string;
    updatedOn?: Date;
}

export class ActionModel implements Action {
    id = 0;
    name = '';
    deadline?: number = null;
    minExpectation?: number = null;
    progress: ActionProgress[] = [];
    weight?: number = null;
    isCommon?: boolean = null;
    comments: Comment[] = [];
    // leaderId = null;
    // leaderProgress = null;
    // leader = null;

    createdBy?: string;
    createdOn?: Date;
    updatedBy?: string;
    updatedOn?: Date;
}